export * from './lib/shared-utils.module';

export * from './lib/elf.utils';
export * from './lib/transloco.utils';
export * from './lib/custom-rxjs.util';
export * from './lib/array.utils';
export * from './lib/mail-color.utils';
export * from './lib/mail-icon.utils';
export * from './lib/mail-status-icon.utils';

export * from './lib/pipes/property-value.pipe';
export * from './lib/pipes/calc-age.pipe';
export * from './lib/pipes/sanitize-image.pipe';
